import { ControlButton, useReactFlow } from "reactflow";
import { useState } from "react";
import { ConnectionLineType } from "reactflow";
import { Menu, MenuItem, ListItemText } from "@mui/material";
import { LineSegments } from "@phosphor-icons/react";

const EDGE_TYPES = [
  { type: ConnectionLineType.Bezier, label: "Bezier" },
  { type: ConnectionLineType.Straight, label: "Straight" },
  { type: ConnectionLineType.Step, label: "Step" },
];

interface LineTypeControlProps {
  lineType: ConnectionLineType;
  setLineType: (type: ConnectionLineType) => void;
}

export const LineTypeControl = ({
  lineType,
  setLineType,
}: LineTypeControlProps) => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const { setEdges } = useReactFlow();

  const handleSelect = (type: ConnectionLineType) => {
    setLineType(type);
    setEdges((edges) => edges.map((e) => ({ ...e, type })));
    setAnchorEl(null);
  };

  return (
    <div>
      <ControlButton
        title="Line type"
        onClick={(e) => setAnchorEl(e.currentTarget)}
      >
        <LineSegments size={16} />
      </ControlButton>

      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={() => setAnchorEl(null)}
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
        transformOrigin={{ vertical: "top", horizontal: "left" }}
      >
        {EDGE_TYPES.map(({ type, label }) => (
          <MenuItem
            key={type}
            selected={lineType === type}
            onClick={() => handleSelect(type)}
          >
            <ListItemText primary={label} />
          </MenuItem>
        ))}
      </Menu>
    </div>
  );
};
